export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
  }
}

async function parse<T>(response: Response): Promise<T> {
  const contentType = response.headers.get("content-type") ?? "";
  const body = contentType.includes("application/json")
    ? ((await response.json()) as { error?: string; code?: string } & T)
    : null;

  if (!response.ok) {
    throw new ApiError(
      body?.error ?? `Request failed (${response.status}).`,
      response.status,
      body?.code,
    );
  }

  return body as T;
}

export async function apiGet<T>(path: string): Promise<T> {
  return parse<T>(await fetch(path, { credentials: "same-origin" }));
}

export async function apiPost<T>(path: string, data?: unknown): Promise<T> {
  return parse<T>(
    await fetch(path, {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data ?? {}),
    }),
  );
}

export async function apiPutFile<T>(path: string, file: File): Promise<T> {
  return parse<T>(
    await fetch(path, {
      method: "PUT",
      credentials: "same-origin",
      headers: {
        "content-type": file.type || "video/mp4",
      },
      body: file,
    }),
  );
}
